import { render, staticRenderFns } from "./SampleRegisterConfirmPopUp.vue?vue&type=template&id=0020f2b1&scoped=true"
import script from "./SampleRegisterConfirmPopUp.vue?vue&type=script&lang=js"
export * from "./SampleRegisterConfirmPopUp.vue?vue&type=script&lang=js"
import style0 from "./SampleRegisterConfirmPopUp.vue?vue&type=style&index=0&id=0020f2b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020f2b1",
  null
  
)

export default component.exports